import React from 'react';
import PropTypes from 'prop-types';
import {Context} from '../MesoAdsContext/MesoAdsContext';
import {Placeholder} from '../Placeholder/Placeholder';

import './MesoAds.less';

export const MesoAds = function({slot}) {
    const component = (
        <div className={`meso-ad-container meso-ad-${slot}`}>
            <Placeholder extraClasses="meso-ad-placeholder" />
            <meso-display-ad uci={slot} slot={slot}/>
        </div>
    );

    return (
        <Context.Consumer>
            {({allowAds}) => allowAds ? component : null}
        </Context.Consumer>
    );
};

MesoAds.propTypes = {
    slot: PropTypes.oneOf(['R1'])
};
